module.exports = __webpack_public_path__ + "img/8.94cbb950.webp";